import React from "react";
import { Draggable } from "react-beautiful-dnd";
import DropdownMenu from "@ats/src/components/shared/DropdownMenu";

import styled from "@emotion/styled";
import { css } from "@emotion/react";

export default function CommentTemplateListItem(props) {
  const { commentTemplate, index, openEditCommentTemplateModal } = props;
  const { name, body, createdByUserFullName } = commentTemplate;

  const handleOpenCommentTemplateModal = (event) => {
    event.preventDefault();

    openEditCommentTemplateModal(commentTemplate);
  };

  const handleDeleteCommentTemplate = async (event) => {
    event.preventDefault();

    props.deleteCommentTemplate(commentTemplate);

    // try {
    //   await deleteCommentTemplate(commentTemplate);
    // } catch (error) {
    //   // Uh oh, something went wrong
    //   window.logger(
    //     "%c[CommentTemplateListItem] handle error when DESTROY Job CommentTemplate",
    //     "color: #FF7602",
    //     {
    //       error,
    //       errorData: error.response.data,
    //     },
    //   );
    // }
  };

  return (
    <Draggable
      draggableId={commentTemplate.id} // required prop
      index={index} // required prop
    >
      {(provided) => {
        return (
          <Styled.Container
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <div>
              <Styled.CommentTemplateText>{name}</Styled.CommentTemplateText>
              <Styled.CommentTemplateDetails>
                Created by {createdByUserFullName != undefined ? createdByUserFullName : "Polymer"}
              </Styled.CommentTemplateDetails>

              {/* <Styled.CommentTemplateDetails>{`${
                Number(commentsCount) > 0 ? commentsCount : "No"
              } active job${
                Number(commentsCount) === 1 ? "" : "s"
              }`}</Styled.CommentTemplateDetails> */}
            </div>
            <DropdownMenu label="Options">
              <a href="" onClick={handleOpenCommentTemplateModal}>
                Edit template
              </a>
              <a href="" onClick={handleDeleteCommentTemplate}>
                Delete template
              </a>
            </DropdownMenu>
          </Styled.Container>
        );
      }}
    </Draggable>
  );
}

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: CommentTemplateListItem;
    ${[t.pl(4), t.pr(3), t.py(3), t.mb("-px")]}
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    border-top: 1px solid ${t.dark ? t.color.gray[700] : t.color.gray[200]};
    background-color: ${t.dark ? t.color.gray[800] : t.color.white};
    transition: background-color 0.2s ease, border-color 0.2s ease;
    &:first-of-type {
      border-top: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
      border-top-left-radius: 0.4375rem;
      border-top-right-radius: 0.4375rem;
    }
    &:last-of-type {
      border-bottom-left-radius: 0.4375rem;
      border-bottom-right-radius: 0.4375rem;
    }
    &:hover,
    &:active {
      border-color: ${t.dark ? t.color.gray[600] : t.color.gray[400]};
      z-index: 16;
    }
  `;
});

Styled.CommentTemplateText = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: CommentTemplateListItem_CommentTemplateText;
    ${t.mb(1)}
    color: ${t.dark ? t.color.gray[200] : t.color.black};
  `;
});

Styled.CommentTemplateDetails = styled.span((props) => {
  const t: any = props.theme;
  return css`
    label: CommentTemplateListItem_CommentTemplateDetails;
    ${[t.text.xs]}
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    max-width: 32rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `;
});
